// extracted by mini-css-extract-plugin
export var cardContainer = "_pa-0";
export var cardHeader = "_pa-2";
export var collapsedState = "_pa-3";
export var dragHandle = "_pa-5";
export var dragHandleIcon = "_pa-6";
export var dragging = "_pa-1";
export var titleArea = "_pa-4";